import * as React from 'react';
import { SettingsMenuView, SettingsMenuViewProps } from './SettingsMenu.view';
import { WithChildren } from '../../../models/children-props';
import { useSelectedOrganization } from '../../../hooks/useSelectedOrganization';
import { useUserRole } from '../../../hooks/useUserRole';
import { useNavigate } from 'react-router-dom';

export type SettingsMenuType = JSX.Element;

export type SettingsMenuControllerProps = WithChildren &
  Omit<
    SettingsMenuViewProps,
    'menuItemClickHandler' | 'logout' | 'selectedOrganization' | 'selectedOrgRole' | 'workspaceName' | 'appRole'
  > & {
    closeAction?: VoidFunction;
    isLeftSideMenu?: boolean;
  };

export const SettingsMenuController = (props: SettingsMenuControllerProps): SettingsMenuType => {
  const navigate = useNavigate();
  const { appRole, selectedOrgRole } = useUserRole();

  const { selectedWorkspace } = useSelectedOrganization();
  const menuItemClickHandler = (url: string) => {
    if (props.closeAction) {
      props.closeAction();
    }
    navigate({ pathname: url });
  };

  const viewProps: SettingsMenuViewProps = {
    ...props,
    menuItemClickHandler,
    selectedOrgRole,
    appRole,
    workspaceName: selectedWorkspace?.name || ''
  };

  return <SettingsMenuView {...viewProps} />;
};
